import { memo, useCallback, useMemo, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { ACTIVITIES } from 'constants/Entities';
import { EntityFiltersActions } from 'actions';
import FilterLateralQuickTour from './FilterLateralQuickTour';
import ExportButtonTour from './ExportButtonTour';
import ImagesAndFilesTour from './ImagesAndFilesTour';
import TimelineTour from './TimelineTour';

const mapStateToProps = (state) => {
    const tours = state.config.components?.tours || {};
    const entityDetail = state?.entityDetail || null;
    const activeDetail = entityDetail?.[entityDetail?.active] || null;
    const tab = activeDetail?.extra?.tab || '';
    return {
        tours,
        tab,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleFilters: bindActionCreators(EntityFiltersActions, dispatch).toggleFilters,
    };
};

const FILTERS_LATERAL_QUICK = 'filters_lateral_quick';
const EXPORT_BUTTON = 'export_button';
const IMAGES_AND_FILES = 'activities_images_and_files_tab';
const TIMELINE = 'timeline';

const toursOrder = [
    // FILTERS_LATERAL_QUICK, it was collapsing with the advancedFiltersTour
    TIMELINE,
    EXPORT_BUTTON,
    IMAGES_AND_FILES,
];

const standardTours = [FILTERS_LATERAL_QUICK, EXPORT_BUTTON, TIMELINE];

const ActivitiesTours = memo(({ tours, toggleFilters }) => {
    const isFirstRender = useRef(true);
    const [nextTour, setNextTour] = useState('');

    const getNextTour = useCallback(() => {
        const activitiesTours = tours?.[ACTIVITIES.entity] || {};
        let disabledTours = [];
        let disabledTourNames = [];
        let areAllToursOlderThanDay = true;

        Object.entries(activitiesTours).forEach(([key, value]) => {
            if (standardTours.includes(key) && value.disabled) {
                disabledTourNames.push(key);
                disabledTours.push({ id: key, ...value });
                if (areAllToursOlderThanDay) {
                    areAllToursOlderThanDay = moment().diff(moment(value.lastShown), 'hours') > 24;
                }
            } else if (value === true) {
                const lastShown = activitiesTours[`${key}_date`] || '';
                disabledTourNames.push(key);
                disabledTours.push({ id: key, disabled: value, lastShown });
                if (areAllToursOlderThanDay) {
                    const days = moment().diff(moment(lastShown), 'hours');
                    if (!isNaN(days)) areAllToursOlderThanDay = days > 24;
                }
            }
        });

        const pendingTours = toursOrder.filter((current) => !disabledTourNames.includes(current));
        if (!pendingTours?.length || !areAllToursOlderThanDay) return '';
        setNextTour(pendingTours[0]);
        return pendingTours[0];
    }, [tours]);

    useEffect(() => {
        if (isFirstRender?.current) {
            isFirstRender.current = false;
            const nextTourToShow = getNextTour();
            if (nextTourToShow === FILTERS_LATERAL_QUICK) toggleFilters(ACTIVITIES);
        }
    }, [getNextTour, toggleFilters]);

    const renderNextTour = useMemo(() => {
        if (!nextTour) return null;

        switch (nextTour) {
            case FILTERS_LATERAL_QUICK:
                return <FilterLateralQuickTour id={FILTERS_LATERAL_QUICK} />;
            case EXPORT_BUTTON:
                return <ExportButtonTour id={EXPORT_BUTTON} />;
            case IMAGES_AND_FILES:
                return <ImagesAndFilesTour />;
            case TIMELINE:
                return <TimelineTour id={TIMELINE} />;
        }
        return null;
    }, [nextTour]);

    return renderNextTour;
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivitiesTours);
